// Redux Toolkit slice for warninglist

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IChemicalModel } from "../../data/ChemicalModel";
import { logOut } from "../actions/user";

export type IWarningListState = {
    show: boolean;
    compound: IChemicalModel | null;
};

const initialState: IWarningListState = {
    show: false,
    compound: null,
};

const warninglistSlice = createSlice({
    name: "warninglist",
    initialState,
    reducers: {
        openWarningList(state, action: PayloadAction<IChemicalModel>) {
            state.show = true;
            state.compound = action.payload;
        },
        closeWarningList(state) {
            state.show = false;
            state.compound = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logOut.request, () => initialState);
    },
});

export const { openWarningList, closeWarningList } = warninglistSlice.actions;
export default warninglistSlice.reducer;
